/* Form component to 2nd unit crew */
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";
import btnStyles from "../../../styles/Button.module.css";
import ExtraCrewMember from "./ExtraCrewMember";
import Alert from "react-bootstrap/Alert";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import toast from "react-hot-toast";

const ExtraCrewInfo = () => {
  const currentUser = useCurrentUser();
  const host = useHostName();
  const [errors, setErrors] = useState({});
  const [crew, setCrew] = useState({ results: [] });

  const [postData, setPostData] = useState({
    name: "",
    position: "",
    email: "",
    phone: "",
  });

  const { name, position, email, phone } = postData;

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const clear = () => {
    /* Function to clear values */
    setPostData({
      name: "",
      position: "",
      email: "",
      phone: "",
    });
  };

  /* function to fetch the extra crew */
  const handleMount = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `/extracrewinfo/?is_second_unit=true`
        );
        if (data?.success === false) {
          throw data.error;
        }
        setCrew(data);
      } else {
        const response = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/extracrewinfo/?is_second_unit=true`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        if (response?.success === false) {
          throw response.error;
        }
        const { data } = response;
        setCrew(data);
      }
    } catch (err) {
      console.log(err);
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to load second unit crew.";
      toast.error(backendError);
    }
  };

  useEffect(() => {
    handleMount();
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Email validation regex
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      toast.error(`Enter a valid email address`, {
        duration: 3000,
        position: "top-right",
      });
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("position", position);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("is_second_unit", true);
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.post("/extracrewinfo/", formData);
        if (data?.success === false) {
          throw data.error;
        }
        toast.success(`Crew Info Updated`);
        setPostData({
          name: "",
          position: "",
          email: "",
          phone: "",
        });
        setCrew((prevCrew) => ({
          ...prevCrew,
          results: [data, ...prevCrew.results],
        }));
      } else {
        const response = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/extracrewinfo/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        if (response?.success === false) {
          throw response.error;
        }
        const { data } = response;
        toast.success(`Crew Info Updated Successfully!`);
        setPostData({
          name: "",
          position: "",
          email: "",
          phone: "",
        });
        setCrew((prevCrew) => ({
          ...prevCrew,
          results: [data, ...prevCrew.results],
        }));
      }
    } catch (err) {
      console.log(err);
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to add crew member.";
      toast.error(backendError);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data || { detail: [backendError] });
      }
    }
  };

  const buttons = (
    <div className="pb-3 text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={clear}
      >
        Cancel
      </Button>
      <Button
        className={`px-3 px-md-5 ml-3 ${btnStyles.Button} ${btnStyles.Blue}`}
        type="submit"
      >
        Submit
      </Button>
    </div>
  );

  return (
    <div className={`${styles.White } mx-md-5`}>
      {currentUser &&
      currentUser?.groups &&
      currentUser?.groups?.length > 0 &&
      (currentUser?.groups[0]?.name === "Superadmin" ||
        currentUser?.groups[0]?.name === "Admin") && (
      <div >
      <Row>
      <Col>
      <div className="d-flex justify-content-center">
      <p className={`text-center mt-3 ${styles.SubTitle4 }`}>ADD NEW POSITION</p>
      </div>
      </Col>
      </Row>
      <Form className={`text-center px-3`} onSubmit={handleSubmit}>
      <Row className="mx-0 my-3">
          <Col className="d-flex justify-content-center mx-0 px-0" xs={6} sm={6} lg={3} >
              <Form.Group controlId="position" className={`${styles.Width95} `}  >
                  <Form.Label className={`${styles.BoldScene}`} >Position</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`} 
                  type="text"
                  name="position"
                  value={position}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.position?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
          </Col>
          <Col className="d-flex justify-content-center mx-0 px-0" xs={6} sm={6} lg={3} >
          <Form.Group controlId="name" className={`${styles.Width95} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Name</Form.Label>
                <Form.Control 
                className={`${styles.Input}`} 
                type="text"
                name="name"
                value={name}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.name?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
          </Col>
          <Col className=" d-flex justify-content-center mt-3 mt-lg-0 mx-0 px-1" xs={6} sm={6} lg={3}>
          <Form.Group controlId="phone" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`} 
              type="text"
              name="phone"
              value={phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col className="d-flex justify-content-center mt-3 mt-lg-0 mx-0 px-0" xs={6} sm={6} lg={3}>
          <Form.Group controlId="email" className={`${styles.Width95} `} >
          <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`} 
              type="text"
              name="email"
              value={email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
        {buttons}
      </Form>
      </div>
      )}
      {/* crew */}
      <div className="text-center mt-3">
      <Row>
      <Col>
      <div className="d-flex justify-content-center">
      <p className={`text-center ${styles.SubTitle4 }`}>POSITIONS</p>
      </div>
      </Col>
      </Row>
      </div>
      <Row className="py-3">
        <Col xs={12}>
          {crew.results?.length
            ? crew.results?.map((crewone) => (
                <ExtraCrewMember
                  key={crewone.id}
                  {...crewone}
                  handleMount={handleMount}
                  crewone={crewone}
                />
              ))
            : ""}
        </Col>
      </Row>
      {/* Break2 */}
      <Row>
      <Col xs={{span: 8, offset: 2}} >
      <hr className={`${styles.Break2 }`}/>
      </Col>
      </Row>
    </div>
  );
};

export default ExtraCrewInfo;